import "core-js/modules/es6.regexp.replace";
//
//
//
//
//
//
//
//
//
//

import { CONST } from '@/utils/const';
export default {
  name: 'AppMain',
  computed: {
    cachedViews: function cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key: function key() {
      return this.$route.path;
    }
  },
  mounted: function mounted() {
    // this.wsLoad()
  },
  beforeDestroy: function beforeDestroy() {
    // this.$store.dispatch('ws/destroyWS', 'msg')
    // this.$store.dispatch('ws/destroyWS', 'notice')
    // this.$store.dispatch('ws/destroyWS', 'rdcsm50')
    // this.$store.dispatch('ws/destroyWS', 'responseData')
  },
  methods: {
    wsLoad: function wsLoad() {
      var url = "".concat(CONST.APIURL.WS.msg, "/").concat(this.$store.state.user.uniqueId, "/").concat(this.$store.state.user.userId);
      this.$store.dispatch('ws/loadWS', {
        url: url,
        name: 'msg'
      });
      var noticeUrl = "".concat(CONST.APIURL.WS.notice.replace(':uniqueId', this.$store.state.user.uniqueId));
      this.$store.dispatch('ws/loadWS', {
        url: noticeUrl,
        name: 'notice'
      });
      var rdcsm50Url = "".concat(CONST.APIURL.WS.rdcsm50, "/").concat(this.$store.state.user.uniqueId, "/").concat(this.$store.state.user.userId);
      this.$store.dispatch('ws/loadWS', {
        url: rdcsm50Url,
        name: 'rdcsm50'
      });
      var responseDataUrl = "".concat(CONST.APIURL.WS.responseData, "/").concat(this.$store.state.user.uniqueId, "/").concat(this.$store.state.user.userId);
      this.$store.dispatch('ws/loadWS', {
        url: responseDataUrl,
        name: 'responseData'
      });
    }
  }
};